import { api, loginapi } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const LoginAPIs = {

    // PostLogin: async function (postJSON, cancel = false){
    //     const response = await loginapi.request({
    //         url: '/authenticate/portaluser',
    //         method: 'POST',
    //         data: postJSON,
    //         headers: {
    //             'Content-Type': 'application/x-authc-username-password+json',
    //         },
    //         signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
    //     })

    //     return {
    //         data: response.data,
    //         status: response.status,
    //         statusText: response.statusText
    //     }
    // },
    PostLogin: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/login',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/x-authc-username-password+json',
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    // PostRegister: async function (postJSON, cancel = false){
    //     const response = await api.request({
    //         url: '/portal/register/user',
    //         method: 'POST',
    //         data: postJSON,
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
    //     })

    //     return {
    //         data: response.data,
    //         status: response.status,
    //         statusText: response.statusText
    //     }
    // },

    PostRegister: async function (postJSON, cancel = false){
        const response = await loginapi.request({
            url: '/register',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostCheckExisting: async function (postJSON, cancel = false){
        const response = await api.request({
            url: '/portal/register/check',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostForgotPassword: async function (postJSON, cancel = false){
        const response = await loginapi.request({
            url: '/forgot-password',
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },

    PostPasswordReset: async function (token, postJSON, cancel = false){
        const response = await loginapi.request({
            url: '/reset-password/' + token,
            method: 'POST',
            data: postJSON,
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }

        // return(
        //     {
        //         status: 200,
        //         data: true
        //     }
        // )
    },
    

    
}
const cancelAPIObject = defineCancelApiObject(LoginAPIs)